export const FETCH_DASHBOARD_LIST_REQUEST = 'FETCH_DASHBOARD_LIST_REQUEST';
export const FETCH_DASHBOARD_LIST_SUCCESS = 'FETCH_DASHBOARD_LIST_SUCCESS';
export const FETCH_DASHBOARD_LIST_FAILURE = 'FETCH_DASHBOARD_LIST_FAILURE';
